// extracted by mini-css-extract-plugin
module.exports = {"sizeRemover":"SizeRemover_sizeRemover__Es8y6"};